export default __webpack_public_path__ + "static/media/_offered.e4f1013b.png";